import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PersonSearchData } from './person.interface';
import { PersonService } from './person.service';

const service = new PersonService();

export interface PersonState {}

const PersonStore: Module<PersonState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async searchPersons(context, searchPersonsInput: PersonSearchData) {
         return service.searchPersons(searchPersonsInput);
      },
   },
};

export default PersonStore;
